var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionIconLogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon icon_login",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    id: "ic_action_Login"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.000000, -2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.40833333,12.9916667 L9.58333333,14.1666667 L13.75,10 L9.58333333,5.83333333 L8.40833333,7.00833333 L10.5583333,9.16666667 L2.5,9.16666667 L2.5,10.8333333 L10.5583333,10.8333333 L8.40833333,12.9916667 Z M15.8333333,2.5 L4.16666667,2.5 C3.24166667,2.5 2.5,3.25 2.5,4.16666667 L2.5,7.5 L4.16666667,7.5 L4.16666667,4.16666667 L15.8333333,4.16666667 L15.8333333,15.8333333 L4.16666667,15.8333333 L4.16666667,12.5 L2.5,12.5 L2.5,15.8333333 C2.5,16.75 3.24166667,17.5 4.16666667,17.5 L15.8333333,17.5 C16.75,17.5 17.5,16.75 17.5,15.8333333 L17.5,4.16666667 C17.5,3.25 16.75,2.5 15.8333333,2.5 Z",
    id: "path-login",
    fill: "#0079ad",
    fillRule: "nonzero"
  })))));
}
export default __webpack_public_path__ + "static/media/ic-action-icon-login.0bcf769d.svg";
export { SvgIcActionIconLogin as ReactComponent };